import * as React from "react"
import { Box } from "@mui/material";
import { ImageSeeker, ModalSeeker } from "@ui-seeker/core";

import { openImageModal, imageModal, titleModal, extraColumnInfo } from "@signals";

export default function ImageModal() {
	return <ModalSeeker hideActions isOpen={openImageModal.value} title={titleModal.value} controller={() => imageModal.value = null}>
		<Box sx={extraColumnInfo.value && {display: 'flex', flexDirection: 'column'}}>
			<Box sx={{textAlign: 'center', ...extraColumnInfo.value && {display: 'flex', justifyContent: 'center'}}}>
				<Box>
					<ImageSeeker src={imageModal.value} height="auto" width="250px"/>
				</Box>

				{extraColumnInfo.value && <Box sx={{width: '500px', textAlign: 'left', pl: 5}}>{extraColumnInfo.value}</Box>}
			</Box>
		</Box>
	</ModalSeeker>
}